
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * TransactionType enum
 */
class TransactionType {
  /**
   * Initialize enum with a given value
   * @param {TransactionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof TransactionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!TransactionType}
   * @param {!TransactionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TransactionType)) {
      throw new TypeError('Instance of TransactionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!TransactionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!TransactionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === TransactionType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === TransactionType.DEPOSIT.value) {
      return 'DEPOSIT'
    }
    if (this.value === TransactionType.CREDIT.value) {
      return 'CREDIT'
    }
    if (this.value === TransactionType.TRANSFER.value) {
      return 'TRANSFER'
    }
    if (this.value === TransactionType.ORDER_OPENED.value) {
      return 'ORDER_OPENED'
    }
    if (this.value === TransactionType.ORDER_FILLED.value) {
      return 'ORDER_FILLED'
    }
    if (this.value === TransactionType.ORDER_FILLED_PARTIALLY.value) {
      return 'ORDER_FILLED_PARTIALLY'
    }
    if (this.value === TransactionType.ORDER_ACTIVATED.value) {
      return 'ORDER_ACTIVATED'
    }
    if (this.value === TransactionType.ORDER_CANCELED.value) {
      return 'ORDER_CANCELED'
    }
    if (this.value === TransactionType.ORDER_EXPIRED.value) {
      return 'ORDER_EXPIRED'
    }
    if (this.value === TransactionType.ORDER_CLOSED.value) {
      return 'ORDER_CLOSED'
    }
    if (this.value === TransactionType.ORDER_CLOSED_PARTIALLY.value) {
      return 'ORDER_CLOSED_PARTIALLY'
    }
    if (this.value === TransactionType.ORDER_REJECTED.value) {
      return 'ORDER_REJECTED'
    }
    if (this.value === TransactionType.ORDER_MODIFIED.value) {
      return 'ORDER_MODIFIED'
    }
    if (this.value === TransactionType.ACCOUNT_CREATED.value) {
      return 'ACCOUNT_CREATED'
    }
    if (this.value === TransactionType.ACCOUNT_MODIFIED.value) {
      return 'ACCOUNT_MODIFIED'
    }
    if (this.value === TransactionType.ACCOUNT_DELETED.value) {
      return 'ACCOUNT_DELETED'
    }
    if (this.value === TransactionType.DIVIDENDS_ADJUSTMENT.value) {
      return 'DIVIDENDS_ADJUSTMENT'
    }
    if (this.value === TransactionType.SPLIT_ADJUSTMENT.value) {
      return 'SPLIT_ADJUSTMENT'
    }
    if (this.value === TransactionType.ACCOUNT_ARCHIVED.value) {
      return 'ACCOUNT_ARCHIVED'
    }
    if (this.value === TransactionType.ACCOUNT_RESTORED.value) {
      return 'ACCOUNT_RESTORED'
    }
    if (this.value === TransactionType.ORDER_TRAILING_UPDATED.value) {
      return 'ORDER_TRAILING_UPDATED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!TransactionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!TransactionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!TransactionType} Created enum
   */
  static fromObject (other) {
    return new TransactionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
TransactionType.UNKNOWN = new TransactionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.DEPOSIT = new TransactionType(1 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.CREDIT = new TransactionType(2 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.TRANSFER = new TransactionType(3 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_OPENED = new TransactionType(4 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_FILLED = new TransactionType(5 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_FILLED_PARTIALLY = new TransactionType(6 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_ACTIVATED = new TransactionType(7 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_CANCELED = new TransactionType(8 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_EXPIRED = new TransactionType(9 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_CLOSED = new TransactionType(10 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_CLOSED_PARTIALLY = new TransactionType(11 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_REJECTED = new TransactionType(12 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_MODIFIED = new TransactionType(13 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ACCOUNT_CREATED = new TransactionType(14 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ACCOUNT_MODIFIED = new TransactionType(15 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ACCOUNT_DELETED = new TransactionType(16 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.DIVIDENDS_ADJUSTMENT = new TransactionType(17 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.SPLIT_ADJUSTMENT = new TransactionType(18 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ACCOUNT_ARCHIVED = new TransactionType(19 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ACCOUNT_RESTORED = new TransactionType(20 + 0)
// noinspection PointlessArithmeticExpressionJS
TransactionType.ORDER_TRAILING_UPDATED = new TransactionType(21 + 0)

export { TransactionType };

/**
 * Fast Binary Encoding TransactionType field model
 */
class FieldModelTransactionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelTransactionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelTransactionType}
   * @param {TransactionType=} defaults Default value, defaults is new TransactionType()
   * @returns {!TransactionType} Result value
   */
  get (defaults = new TransactionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new TransactionType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelTransactionType}
   * @param {!TransactionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelTransactionType };
